import { Component, Input } from '@angular/core';
import { locationsRoute } from 'src/app/app-routing.module';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { LocationPrivileges } from '../models/location-privileges';
import { LocationsOrderingOptions, LocationsRegisterOptions } from '../models/locations-register-options';
import { LocationsRegisterListItem } from '../models/locations-register-results.model';
import { selectQuickFilters } from '../state/locations-register.reducer';

@Component({
    selector: 'ndt-locations-register-view',
    templateUrl: './locations-register-view.component.html',
    standalone: false
})
export class LocationsRegisterViewComponent extends EntityRegisterView<
   LocationsRegisterListItem,
   LocationsRegisterOptions,
   LocationsOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => LocationsRegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() locationPrivileges: LocationPrivileges;

   @Input()
   getRouterLink(id: number) {
      return `/${locationsRoute}/${id}`;
   }
}
